import { render, staticRenderFns } from "./EmrCheckMophImmigration.vue?vue&type=template&id=53a5e8a3&"
import script from "./EmrCheckMophImmigration.vue?vue&type=script&lang=js&"
export * from "./EmrCheckMophImmigration.vue?vue&type=script&lang=js&"
import style0 from "./EmrCheckMophImmigration.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports